import { appConfig } from '@app/shared/config'

export const colorLog = (message?: string, options?: { color?: string; background?: string }) =>
  console.log(
    `%c${message}`,
    `
      color: ${options?.color || 'white'};
      background: ${options?.background || 'black'};
      padding: 10px;
      font-weight: bold;
      font-size: 16px;
      border-radius: 5px;
    `,
  )

/**
 * Escape string from all html specific tags
 * @param html
 * @returns escaped string
 */
export const escapeHtml = (html: string) => {
  if (!html) return ''

  return html
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
    .replace(/`(.*?)`/g, '<code>$1</code>')
}

/**
 * Set page title based on app config + provided title
 * @param title
 */
export const setPageTitle = (title: string) => {
  document.title = `${title} - ${localStorage.getItem("appTitle") || appConfig.appTitle}`;
}

/**
 * Transform html form to object
 * @param form
 * @returns object
 */
export const serializeForm = (form: HTMLFormElement) => {
  return Object.fromEntries(new FormData(form).entries())
}

/**
 * Format bytes to user readable
 * @param bytes
 * @param decimals
 * @returns pretty string
 */
export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * Finds the closest element in a list of HTMLElements that the given y-coordinate is hovering over,
 * specifically targeting the element whose vertical center is closest to the y-coordinate from above.
 * @param elements
 * @param y
 * @returns HTMLElement
 */
export const dragginOverElement = (elements: HTMLElement[], y: number) => {
  const { element } = elements.reduce<{ offset: number; element: HTMLElement | null }>(
    (closest, el) => {
      const rect = el.getBoundingClientRect()
      const offset = y - rect.top - rect.height / 2
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: el }
      }
      return closest
    },
    { offset: Number.NEGATIVE_INFINITY, element: null },
  )
  return element
}

/**
 * Truncate string by word
 * @param value
 * @param max
 * @returns truncated string
 */
export const truncateByWord = (value: string, max: number) => {
  if (value.length <= max) return value

  // Cut the string to the max length
  let truncated = value.slice(0, max)

  // Find the last space to avoid cutting a word in half
  const lastSpaceIndex = truncated.lastIndexOf(' ')

  if (lastSpaceIndex > 0) {
    truncated = truncated.slice(0, lastSpaceIndex)
  }
  return `${truncated}...`
}
